import { apiClient } from './client'
import type { ApiResponse } from '@/types/api'

/**
 * 콘텐츠 검수 > 레슨 > 문제 커버리지.
 * quiz-mgt(허브) 문제를 qmgt-purpose 태그에서 온 purpose별로 묶은 응답.
 * 기획: docs/features/admin-content-inspection/quiz-coverage-plan.md
 */
export type QuizPurpose = 'practice' | 'diagnose' | 'thinking' | 'imagination'

export interface QuizCoverageQuiz {
  /** big int라 문자열 */
  quizId: string
  hubItemId: string
  hubK: number
  purpose: string | null
  misconceptions: string[]
  locations: string[]
}

export interface QuizCoveragePurposeGroup {
  /** practice·diagnose·thinking·imagination 고정 순서. 목적 없는 허브 문제가 있으면 null 그룹이 마지막에 온다. */
  purpose: string | null
  quizCount: number
  itemCount: number
  quizzes: QuizCoverageQuiz[]
}

export interface QuizCoverageResponse {
  contentId: number
  hubQuizCount: number
  hubItemCount: number
  nonHubQuizCount: number
  excludedDeletedCount: number
  /** ISO 문자열 (Z 포함). 허브 문제가 없으면 null */
  lastSyncedAt: string | null
  purposes: QuizCoveragePurposeGroup[]
}

export async function getQuizCoverage(contentId: number): Promise<QuizCoverageResponse> {
  const res = await apiClient.get<ApiResponse<QuizCoverageResponse>>(
    `/admin/content-inspection/contents/${contentId}/quiz-coverage`,
  )
  if (!res.data.data) throw new Error('문제 커버리지 응답이 비어 있습니다.')
  return res.data.data
}
